import { Box, Button, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { LogsDialog } from "pages/admin/setting/EmployeePage";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SignaturePad from 'react-signature-canvas';
import { getRoleList } from "redux/modules/roleSlice";
import { getEmployeeDetail, updateEmployee } from "redux/modules/employeeSlice";
import * as yup from 'yup';
import FileService from "services/FileService";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import mime from "mime";
import { RoleId } from "libs/configs/constant";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  wrapContent: {
    marginTop: 30
  },
  sigPad: { width: "100%", height: "100%" }, buttons: { width: "100%", height: "30px" },
  wrapSig: { padding: "10px", border: "1px solid lightgray", borderRadius: "10px", textAlign: "center" },
  sigImage: {
    backgroundSize: "200px 50px", width: "80%", height: "80%", backgroundColor: "white", borderRadius: 15
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",

  },
  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  wrapContoller: {
    display: 'flex',
  },
  formControl: {
    width: '100%'
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10
  },
}));

function EmployeeDetailPage() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const sigPad = useRef({});
  const params = useParams();
  const empId = get(params, "empId", "") || "";
  const [open, setOpen] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({});
  const [signDataUri, setSignDataUri] = useState(null);
  const { detail: empDetail } = useSelector((state) => state.employee);
  const { list: roleList, isLoading } = useSelector((state) => state.role);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector(
    (state) => state.user
  );


  useEffect(async () => {
    if (empId) {
      await dispatch(getRoleList());
      await dispatch(getEmployeeDetail(empId));


    }
  }, [empId])


  useEffect(async () => {
    if (empDetail?.signatureFileID) {
      const data = await FileService.getFile(empDetail?.signatureFileID);
      try {
        const fileName = empDetail.filename + empDetail.ext;
        const blobFile = new File([data], fileName, {
          type: mime.getType(empDetail.ext),
        });

        console.log(URL.createObjectURL(blobFile));
        setSignDataUri(URL.createObjectURL(blobFile))
      } catch (error) {
        console.error(error);
      }
    }
  }, [empDetail])



  const handleClose = async (value) => {
    setOpen(false);
  };

  const clear = () => {
    sigPad.current.clear()
    setSignDataUri(null);

  }
  const trim = async () => {
    // setSignDataUri(sigPad.current.getTrimmedCanvas().toDataURL('image/png'))
    showAdminLoading();

    const sigFile = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
    const filesignDataUri = await fetch(sigFile)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], "signImg.png", { type: "image/png" })
        return file
      })


    const resSign = await FileService.uploadFile({
      file: filesignDataUri,
      Status: true,
    });

    if (resSign.status) {

      const signFileId = resSign.results?.fileID;
      const body = {
        empId: empId,
        departmentId: empDetail?.departmentId,
        email: empDetail?.email,
        employeeNo: empDetail?.employeeNo,
        employeeFistName: empDetail?.employeeFistName,
        employeeLastName: empDetail?.employeeLastName,
        position: empDetail?.position,
        roleId: empDetail?.roleId,
        signatureFileID: signFileId,
        status: empDetail?.status,
      };
      await dispatch(updateEmployee(body));
    }

    hideAdminLoading();

  }

  const validationSchema = yup.object({
    // date: yup.date().required("Date is required."),
    employeeFistName: yup.string().trim().required("First name is required."),
    employeeLastName: yup.string().trim().required("Last name is required."),
    email: yup.string().trim().required("Email is required."),
    position: yup.string().trim().required("Position is required."),
    roleId: yup.string().ensure().trim().required("Role is required."),
  });



  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      email: empDetail?.email,
      employeeFistName: empDetail?.employeeFistName,
      employeeLastName: empDetail?.employeeLastName,
      position: empDetail?.position,
      roleId: empDetail?.roleId,
      departmentName: empDetail?.departmentName,
    },
    onSubmit: async (c) => {
      showAdminLoading();

      const body = {
        empId: empId,
        departmentId: empDetail?.departmentId,
        email: c?.email,
        employeeNo: empDetail?.employeeNo,
        employeeFistName: c?.employeeFistName,
        employeeLastName: c?.employeeLastName,
        position: c?.position,
        roleId: empDetail?.roleId,
        signatureFileID: empDetail?.signatureFileID,
        status: empDetail?.status,
      };
      await dispatch(updateEmployee(body));
      hideAdminLoading();
    },
  });




  useEffect(async () => {
    if (formik) {
      formik.setFieldValue('roleId', empDetail?.roleId);
    }
  }, [roleList, empDetail?.roleId]);


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Employee" />
      <LogsDialog data={dialogData} open={open} onClose={handleClose} />
      <form onSubmit={formik.handleSubmit} id="emp-form">
        <div className={classes.warpSubHeader} >
          <AdminTitle2 subTitle="Employee Informations" />
          <div className={classes.wrapContoller}>


            <Button variant="outlined" size="medium" color="primary"
              style={{ marginRight: 10 }}
              type="button"
              onClick={() => {
                setDialogData({ empId: empId })
                setOpen(true);
              }}
              className={classes.buttonDialogSave}>
              Logs
            </Button>
            <Button variant="contained" size="medium" color="primary"
              type="submit"
              onClick={() => {

              }}
              className={classes.buttonDialogSave}>
              Save
            </Button>
          </div>



        </div >

        <div className={classes.wrapContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4} >
              <div className={classes.wrapField}>
                <InputLabel>First Name</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeFistName"
                  value={formik.values.employeeFistName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeFistName", formik)}
                  helperText={getErrorMessage("employeeFistName", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Last Name</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeLastName"
                  value={formik.values.employeeLastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeLastName", formik)}
                  helperText={getErrorMessage("employeeLastName", formik)}
                />
              </div>
            </Grid>
            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Position</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="position"
                  value={formik.values.position}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("position", formik)}
                  helperText={getErrorMessage("position", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Role</InputLabel>
                <Select
                  id="roleId"
                  name="roleId"
                  disabled={profile?.roleId !== RoleId.Director}
                  className={classes.textField}
                  variant="outlined"
                  value={formik.values.roleId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {roleList.filter(x => x.status === 'Y' && x.roleLevel >= 2 && x.roleLevel <= 4).map((row) => (
                    <MenuItem
                      value={row.roleId}
                      key={row.roleId}
                    >
                      {row.roleName}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Email</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("email", formik)}
                  helperText={getErrorMessage("email", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>

              <div className={classes.wrapField}>
                <InputLabel>Department</InputLabel>
                <TextField
                  variant="outlined"
                  disabled
                  className={classes.textField}
                  name="departmentName"
                  value={formik.values.departmentName}
                />
              </div>
            </Grid>

            <Box width="100%" style={{ marginTop: 15 }} />
            <Grid item xs={12} md={8}>
              <div className={classes.sigContainer}>
                {
                  !signDataUri &&
                  <div style={{ border: "1px solid darkgray", borderRadius: "15px" }}>
                    <SignaturePad
                      canvasProps={{ className: classes.sigPad }}
                      ref={sigPad} />
                  </div>

                }
                {signDataUri
                  ? <div className={classes.wrapSig}>
                    <img className={classes.sigImage}
                      src={signDataUri} />
                  </div>
                  : null}
              </div>
            </Grid>
            <Grid item xs={12} md={3}>

              {
                signDataUri &&
                <>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      type="button"
                      onClick={() => {
                        setSignDataUri(null);
                      }}
                      className={classes.buttonViewDetail}>
                      New Signature
                    </Button>
                  </div>
                </>
              }
              {
                !signDataUri &&
                <>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={clear}
                      type="button"
                      className={classes.buttonViewDetail}>
                      Clear
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="button"
                      onClick={() => {
                        trim();
                      }}
                      className={classes.buttonViewDetail}>
                      OK
                    </Button>
                  </div>
                </>
              }
            </Grid>
          </Grid>
        </div>
      </form>
    </Paper >
  );
}

export default EmployeeDetailPage;

